import React, { useState, useEffect } from 'react';

const IDDSI_FOOD_LEVELS = [
  { level: 3, name: 'Liquidised', color: '#F4A460' },
  { level: 4, name: 'Pureed', color: '#E07020' },
  { level: 5, name: 'Minced & Moist', color: '#C92D2D' },
  { level: 6, name: 'Soft & Bite-Sized', color: '#2D7DC9' },
  { level: 7, name: 'Regular', color: '#4A4A4A' },
];

const IDDSI_DRINK_LEVELS = [
  { level: 0, name: 'Thin', color: '#87CEEB' },
  { level: 1, name: 'Slightly Thick', color: '#B8B8B8' },
  { level: 2, name: 'Mildly Thick', color: '#FFB6C1' },
  { level: 3, name: 'Moderately Thick', color: '#F4A460' },
  { level: 4, name: 'Extremely Thick', color: '#E07020' },
];

const FOOD_CATEGORIES = [
  'proteins', 'vegetables', 'carbohydrates', 'dairy', 'fruits', 'beverages', 'desserts', 'snacks'
];

// Styles
const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #F8F9FA 0%, #E9ECEF 100%)',
    fontFamily: '"Nunito", "Segoe UI", sans-serif',
  },
  header: {
    background: 'linear-gradient(135deg, #495057 0%, #343A40 100%)',
    padding: '20px 24px',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    margin: 0,
    fontSize: '24px',
    fontWeight: '700',
  },
  main: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '24px',
  },
  tabs: {
    display: 'flex',
    gap: '8px',
    marginBottom: '24px',
  },
  tab: (active) => ({
    padding: '12px 24px',
    fontSize: '15px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: active ? '#FF6B35' : 'white',
    color: active ? 'white' : '#495057',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  }),
  card: {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '24px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
    marginBottom: '20px',
  },
  cardTitle: {
    margin: '0 0 20px',
    fontSize: '18px',
    fontWeight: '700',
    color: '#212529',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    textAlign: 'left',
    padding: '12px 16px',
    borderBottom: '2px solid #E9ECEF',
    color: '#6C757D',
    fontSize: '13px',
    fontWeight: '600',
    textTransform: 'uppercase',
  },
  td: {
    padding: '16px',
    borderBottom: '1px solid #E9ECEF',
    fontSize: '14px',
  },
  badge: (color) => ({
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '20px',
    backgroundColor: color,
    color: 'white',
    fontSize: '12px',
    fontWeight: '600',
  }),
  btn: (variant = 'primary') => ({
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor: variant === 'primary' ? '#FF6B35' : variant === 'danger' ? '#DC3545' : '#6C757D',
    color: 'white',
  }),
  btnSmall: (variant = 'secondary') => ({
    padding: '6px 12px',
    fontSize: '12px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    backgroundColor: variant === 'danger' ? '#DC3545' : variant === 'primary' ? '#FF6B35' : '#E9ECEF',
    color: variant === 'danger' || variant === 'primary' ? 'white' : '#495057',
    marginRight: '8px',
  }),
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '15px',
    border: '2px solid #E9ECEF',
    borderRadius: '8px',
    boxSizing: 'border-box',
    marginBottom: '12px',
  },
  select: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '15px',
    border: '2px solid #E9ECEF',
    borderRadius: '8px',
    boxSizing: 'border-box',
    marginBottom: '12px',
    backgroundColor: 'white',
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#6C757D',
    marginBottom: '6px',
    textTransform: 'uppercase',
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '32px',
    width: '90%',
    maxWidth: '500px',
    maxHeight: '90vh',
    overflow: 'auto',
  },
  restrictionTag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    backgroundColor: '#FEE2E2',
    color: '#991B1B',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    marginRight: '6px',
    marginBottom: '6px',
  },
  statusBadge: (status) => ({
    display: 'inline-block',
    padding: '3px 8px',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: '600',
    backgroundColor: status === 'ok' ? '#D1FAE5' : status === 'modify' ? '#FEF3C7' : '#FEE2E2',
    color: status === 'ok' ? '#065F46' : status === 'modify' ? '#92400E' : '#991B1B',
  }),
};

// Profile Form Modal
function ProfileModal({ profile, onSave, onClose }) {
  const [form, setForm] = useState(profile || {
    name: '', roomNumber: '', foodLevel: 5, drinkLevel: 0, notes: '', dietaryRestrictions: []
  });
  const [newRestriction, setNewRestriction] = useState('');

  const addRestriction = () => {
    if (newRestriction.trim() && !form.dietaryRestrictions.includes(newRestriction.trim())) {
      setForm({ ...form, dietaryRestrictions: [...form.dietaryRestrictions, newRestriction.trim()] });
      setNewRestriction('');
    }
  };

  const removeRestriction = (r) => {
    setForm({ ...form, dietaryRestrictions: form.dietaryRestrictions.filter(x => x !== r) });
  };

  return (
    <div style={styles.modal} onClick={onClose}>
      <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 24px', fontSize: '20px', fontWeight: '700' }}>
          {profile ? 'Edit Person' : 'Add New Person'}
        </h2>

        <label style={styles.label}>Name *</label>
        <input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Full name" />

        <label style={styles.label}>Room Number</label>
        <input style={styles.input} value={form.roomNumber} onChange={e => setForm({ ...form, roomNumber: e.target.value })} placeholder="e.g. Room 12" />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div>
            <label style={styles.label}>Food Level *</label>
            <select style={styles.select} value={form.foodLevel} onChange={e => setForm({ ...form, foodLevel: parseInt(e.target.value) })}>
              {IDDSI_FOOD_LEVELS.map(l => (
                <option key={l.level} value={l.level}>Level {l.level} - {l.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label style={styles.label}>Drink Level</label>
            <select style={styles.select} value={form.drinkLevel} onChange={e => setForm({ ...form, drinkLevel: parseInt(e.target.value) })}>
              {IDDSI_DRINK_LEVELS.map(l => (
                <option key={l.level} value={l.level}>Level {l.level} - {l.name}</option>
              ))}
            </select>
          </div>
        </div>

        <label style={styles.label}>Allergies & Restrictions</label>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
          <input 
            style={{ ...styles.input, marginBottom: 0, flex: 1 }} 
            value={newRestriction} 
            onChange={e => setNewRestriction(e.target.value)}
            placeholder="e.g. shellfish, nuts, gluten"
            onKeyDown={e => e.key === 'Enter' && addRestriction()}
          />
          <button style={styles.btn('primary')} onClick={addRestriction}>Add</button>
        </div>
        <div style={{ marginBottom: '12px' }}>
          {form.dietaryRestrictions.map(r => (
            <span key={r} style={styles.restrictionTag}>
              {r}
              <span style={{ cursor: 'pointer' }} onClick={() => removeRestriction(r)}>×</span>
            </span>
          ))}
        </div>

        <label style={styles.label}>Notes</label>
        <textarea 
          style={{ ...styles.input, minHeight: '80px', resize: 'vertical' }} 
          value={form.notes} 
          onChange={e => setForm({ ...form, notes: e.target.value })}
          placeholder="Additional notes about preferences or requirements"
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
          <button style={styles.btn('secondary')} onClick={onClose}>Cancel</button>
          <button style={styles.btn('primary')} onClick={() => onSave(form)} disabled={!form.name}>
            {profile ? 'Save Changes' : 'Add Person'}
          </button>
        </div>
      </div>
    </div>
  );
}

// Food Form Modal
function FoodModal({ food, onSave, onClose }) {
  const [form, setForm] = useState(food || {
    name: '', category: 'proteins', preparationTips: '',
    levels: { 3: { status: 'modify', notes: '' }, 4: { status: 'modify', notes: '' }, 5: { status: 'ok', notes: '' }, 6: { status: 'ok', notes: '' }, 7: { status: 'ok', notes: '' } }
  });

  const updateLevel = (level, field, value) => {
    setForm({
      ...form,
      levels: { ...form.levels, [level]: { ...form.levels[level], [field]: value } }
    });
  };

  return (
    <div style={styles.modal} onClick={onClose}>
      <div style={{ ...styles.modalContent, maxWidth: '600px' }} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 24px', fontSize: '20px', fontWeight: '700' }}>
          {food ? 'Edit Food' : 'Add Pre-Approved Food'}
        </h2>

        <label style={styles.label}>Food Name *</label>
        <input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Mashed Potato" />

        <label style={styles.label}>Category *</label>
        <select style={styles.select} value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
          {FOOD_CATEGORIES.map(c => (
            <option key={c} value={c}>{c.charAt(0).toUpperCase() + c.slice(1)}</option>
          ))}
        </select>

        <label style={styles.label}>Suitability by IDDSI Level</label>
        <div style={{ border: '1px solid #E9ECEF', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
          {IDDSI_FOOD_LEVELS.map(l => (
            <div key={l.level} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', borderBottom: l.level < 7 ? '1px solid #E9ECEF' : 'none' }}>
              <span style={{ ...styles.badge(l.color), minWidth: '100px', textAlign: 'center' }}>Level {l.level}</span>
              <select 
                style={{ ...styles.select, marginBottom: 0, width: '120px' }} 
                value={form.levels[l.level]?.status || 'ok'}
                onChange={e => updateLevel(l.level, 'status', e.target.value)}
              >
                <option value="ok">✅ OK</option>
                <option value="modify">⚠️ Modify</option>
                <option value="avoid">❌ Avoid</option>
              </select>
              <input 
                style={{ ...styles.input, marginBottom: 0, flex: 1 }} 
                placeholder="Notes for this level"
                value={form.levels[l.level]?.notes || ''}
                onChange={e => updateLevel(l.level, 'notes', e.target.value)}
              />
            </div>
          ))}
        </div>

        <label style={styles.label}>Preparation Tips</label>
        <textarea 
          style={{ ...styles.input, minHeight: '80px', resize: 'vertical' }} 
          value={form.preparationTips} 
          onChange={e => setForm({ ...form, preparationTips: e.target.value })}
          placeholder="General preparation guidance for this food"
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
          <button style={styles.btn('secondary')} onClick={onClose}>Cancel</button>
          <button style={styles.btn('primary')} onClick={() => onSave(form)} disabled={!form.name}>
            {food ? 'Save Changes' : 'Add Food'}
          </button>
        </div>
      </div>
    </div>
  );
}

// Main Admin Panel
export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState('profiles');
  const [profiles, setProfiles] = useState([]);
  const [foods, setFoods] = useState([]);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showFoodModal, setShowFoodModal] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);
  const [editingFood, setEditingFood] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // Fetch data
  useEffect(() => {
    fetchProfiles();
    fetchFoods();
  }, []);

  const fetchProfiles = async () => {
    try {
      const res = await fetch('/api/profiles', { headers: { 'X-API-Key': 'demo-api-key-12345' } });
      const data = await res.json();
      setProfiles(data.data || []);
    } catch (err) {
      console.error('Failed to fetch profiles:', err);
    }
  };

  const fetchFoods = async () => {
    try {
      const res = await fetch('/api/common-foods', { headers: { 'X-API-Key': 'demo-api-key-12345' } });
      const data = await res.json();
      setFoods(data.data || []);
    } catch (err) {
      console.error('Failed to fetch foods:', err);
    }
  };

  const saveProfile = async (profile) => {
    try {
      const method = profile.id ? 'PUT' : 'POST';
      const url = profile.id ? `/api/profiles/${profile.id}` : '/api/profiles';
      await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'X-API-Key': 'demo-api-key-12345' },
        body: JSON.stringify(profile),
      });
      fetchProfiles();
      setShowProfileModal(false);
      setEditingProfile(null);
    } catch (err) {
      console.error('Failed to save profile:', err);
    }
  };

  const deleteProfile = async (id) => {
    if (!confirm('Are you sure you want to remove this person\'s profile?')) return;
    try {
      await fetch(`/api/profiles/${id}`, {
        method: 'DELETE',
        headers: { 'X-API-Key': 'demo-api-key-12345' },
      });
      fetchProfiles();
    } catch (err) {
      console.error('Failed to delete profile:', err);
    }
  };

  const saveFood = async (food) => {
    try {
      const method = food.id ? 'PUT' : 'POST';
      const url = food.id ? `/api/common-foods/${food.id}` : '/api/common-foods';
      await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'X-API-Key': 'demo-api-key-12345' },
        body: JSON.stringify(food),
      });
      fetchFoods();
      setShowFoodModal(false);
      setEditingFood(null);
    } catch (err) {
      console.error('Failed to save food:', err);
    }
  };

  const deleteFood = async (id) => {
    if (!confirm('Are you sure you want to delete this food?')) return;
    try {
      await fetch(`/api/common-foods/${id}`, {
        method: 'DELETE',
        headers: { 'X-API-Key': 'demo-api-key-12345' },
      });
      fetchFoods();
    } catch (err) {
      console.error('Failed to delete food:', err);
    }
  };

  const filteredProfiles = profiles.filter(p => 
    p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.roomNumber?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredFoods = foods.filter(f => 
    f.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    f.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getFoodLevel = (level) => IDDSI_FOOD_LEVELS.find(l => l.level === level);
  const getDrinkLevel = (level) => IDDSI_DRINK_LEVELS.find(l => l.level === level);

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>⚙️ IDDSI Check Admin</h1>
        <a href="/" style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>← Back to Checker</a>
      </header>

      <main style={styles.main}>
        {/* Tabs */}
        <div style={styles.tabs}>
          <button style={styles.tab(activeTab === 'profiles')} onClick={() => setActiveTab('profiles')}>
            👥 People ({profiles.length})
          </button>
          <button style={styles.tab(activeTab === 'foods')} onClick={() => setActiveTab('foods')}>
            🍽️ Pre-Approved Foods ({foods.length})
          </button>
        </div>

        {/* Search */}
        <div style={{ marginBottom: '20px' }}>
          <input 
            style={{ ...styles.input, maxWidth: '400px', marginBottom: 0 }}
            placeholder={activeTab === 'profiles' ? 'Search people...' : 'Search foods...'}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Profiles Tab */}
        {activeTab === 'profiles' && (
          <div style={styles.card}>
            <div style={styles.cardTitle}>
              <span>People</span>
              <button style={styles.btn('primary')} onClick={() => { setEditingProfile(null); setShowProfileModal(true); }}>
                + Add Person
              </button>
            </div>

            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Name</th>
                  <th style={styles.th}>Room</th>
                  <th style={styles.th}>Food Level</th>
                  <th style={styles.th}>Drink Level</th>
                  <th style={styles.th}>Restrictions</th>
                  <th style={styles.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredProfiles.map(p => {
                  const foodL = getFoodLevel(p.foodLevel);
                  const drinkL = getDrinkLevel(p.drinkLevel);
                  return (
                    <tr key={p.id}>
                      <td style={styles.td}><strong>{p.name}</strong></td>
                      <td style={styles.td}>{p.roomNumber || '-'}</td>
                      <td style={styles.td}>
                        <span style={styles.badge(foodL?.color || '#666')}>L{p.foodLevel} {foodL?.name}</span>
                      </td>
                      <td style={styles.td}>
                        <span style={styles.badge(drinkL?.color || '#666')}>L{p.drinkLevel} {drinkL?.name}</span>
                      </td>
                      <td style={styles.td}>
                        {p.dietaryRestrictions?.length ? p.dietaryRestrictions.map(r => (
                          <span key={r} style={styles.restrictionTag}>{r}</span>
                        )) : '-'}
                      </td>
                      <td style={styles.td}>
                        <button style={styles.btnSmall('primary')} onClick={() => { setEditingProfile(p); setShowProfileModal(true); }}>Edit</button>
                        <button style={styles.btnSmall('danger')} onClick={() => deleteProfile(p.id)}>Delete</button>
                      </td>
                    </tr>
                  );
                })}
                {filteredProfiles.length === 0 && (
                  <tr><td colSpan={6} style={{ ...styles.td, textAlign: 'center', color: '#6C757D' }}>No people found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Foods Tab */}
        {activeTab === 'foods' && (
          <div style={styles.card}>
            <div style={styles.cardTitle}>
              <span>Pre-Approved Foods Database</span>
              <button style={styles.btn('primary')} onClick={() => { setEditingFood(null); setShowFoodModal(true); }}>
                + Add Food
              </button>
            </div>

            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Food</th>
                  <th style={styles.th}>Category</th>
                  <th style={styles.th}>L3</th>
                  <th style={styles.th}>L4</th>
                  <th style={styles.th}>L5</th>
                  <th style={styles.th}>L6</th>
                  <th style={styles.th}>L7</th>
                  <th style={styles.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredFoods.map(f => (
                  <tr key={f.id}>
                    <td style={styles.td}><strong>{f.name}</strong></td>
                    <td style={styles.td}>{f.category}</td>
                    {[3, 4, 5, 6, 7].map(level => (
                      <td key={level} style={styles.td}>
                        <span style={styles.statusBadge(f.levels?.[level]?.status || 'ok')}>
                          {f.levels?.[level]?.status === 'ok' ? '✓' : f.levels?.[level]?.status === 'modify' ? '⚠' : '✗'}
                        </span>
                      </td>
                    ))}
                    <td style={styles.td}>
                      <button style={styles.btnSmall('primary')} onClick={() => { setEditingFood(f); setShowFoodModal(true); }}>Edit</button>
                      <button style={styles.btnSmall('danger')} onClick={() => deleteFood(f.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
                {filteredFoods.length === 0 && (
                  <tr><td colSpan={8} style={{ ...styles.td, textAlign: 'center', color: '#6C757D' }}>No foods found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </main>

      {/* Modals */}
      {showProfileModal && (
        <ProfileModal 
          profile={editingProfile} 
          onSave={saveProfile} 
          onClose={() => { setShowProfileModal(false); setEditingProfile(null); }} 
        />
      )}
      {showFoodModal && (
        <FoodModal 
          food={editingFood} 
          onSave={saveFood} 
          onClose={() => { setShowFoodModal(false); setEditingFood(null); }} 
        />
      )}
    </div>
  );
}
